import { Box } from '@chakra-ui/react'
import { useRef } from 'react'
import { Transition } from 'react-transition-group'

import heloLogo from '../../assets/logo/helo-logo.svg'
import heloText from '../../assets/logo/helo-text.svg'

interface LogoProps {
  isExpanded: boolean
}
export const transitions: any = {
  entering: {
    opacity: 0,
  },
  entered: {
    transition: `all 250ms ease-in 250ms`,
    opacity: 1,
  },
  exiting: {
    transition: `all 250ms ease-in`,
    opacity: 0,
  },
  exited: {
    display: 'none',
    opacity: 0,
  },
}

export const Logo = ({ isExpanded = false }: LogoProps) => {
  const ref = useRef(null)
  return (
    <Box height="48px" flexDirection="row" display="flex" gap="8px">
      <Box
        as="img"
        src={heloLogo}
        width="45px"
        height="36px"
        margin="2.25px 0 9.75px"
      ></Box>
      <Transition nodeRef={ref} in={isExpanded} timeout={500}>
        {state => (
          <Box
            ref={ref}
            as="img"
            src={heloText}
            width="75px"
            height="38px"
            margin="8.45px 0 10.25px"
            {...transitions[state]}
          ></Box>
        )}
      </Transition>
    </Box>
  )
}
